import * as actionTypes from './actionTypes'
import axios from '../../services/services'

export const setProduct = (product) => {
    return {
        type: actionTypes.SET_PRODUCT,
        product: product
    }
}

export const setCurrentState = (price, period, delieverFee,qty) => {
    return {
        type: actionTypes.SET_CURRENTPRODUCTSTATE,
        currentPrice: price,
        currentDeliveryPeriod:period,
        currentDelieverFee:delieverFee,
        currentQty:qty
    }
}


export const fetchProduct = (category, id) => { 
    return dispatch => {
        axios.productServices.getProductDetail(category,id)
            .then(res => {
                dispatch(setProduct(res.data.result))
            })
            .catch(err => {
                dispatch(fetchProductFail(err))
            })
    }
} 

export const fetchProductFail = (error) => {
    return {
        type: actionTypes.FETCH_PRODUCT_FAIL,
        error:error
    }
}


export const addToCart = (product,attributesId, qty) =>{
    return {
        type: actionTypes.ADD_TO_CART,
        product:product,
        attributesId:attributesId,
        qty:qty
    }

}

export const fetchCartSuccess = (product)=>{
    return{
        type:actionTypes.FETCH_CART_SUCCESS,
        product:product
    }
}

export const removeFromCart = (id)=>{
    return dispatch=>{ 
        axios.productServices.removeProduct(id)
        .then(res=>{
            dispatch(getAllCartService())
        })
        .catch(err =>{

        })
    }
}

export const addCartService = (product,attributesId, qty)=>{
    return dispatch=>{ 
        const formData = new FormData()
        formData.append('product_id',product.id)
        formData.append('attribute_id',attributesId)
        formData.append('quantity',qty)
        axios.productServices.addToCart(formData)
        .then(res=>{
            dispatch(getAllCartService())
        })
        .catch(err =>{

        })
    }
}

export const getAllCartService = () =>{
    return dispatch=>{
        axios.productServices.getAllCart()
        .then(res=>{
            console.log(res)
            dispatch(fetchCartSuccess(res.data.result))
        })
        .catch(err=>{

        })
    }
}


export const addProduct = (product) => {
    return {
        type: actionTypes.ADD_PRODUCT,
        product:product
    }
}